// src/pages/ConsultaAbastecimiento.jsx
import React, { useEffect, useState } from "react";
import axios from "axios";
import { Table, Input, Typography, Spin, Card, Button, Space, Modal } from "antd";
import {
  ReloadOutlined,
  EyeOutlined,
  FullscreenOutlined,
  FullscreenExitOutlined,
} from "@ant-design/icons";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

const { Title } = Typography;
const { Search } = Input;

const ConsultaAbastecimiento = () => {
  const [casos, setCasos] = useState([]);
  const [filteredCasos, setFilteredCasos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [modalLoading, setModalLoading] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(false);

  // 🔹 Columnas para la tabla
  const columns = [
    { title: "ID", dataIndex: "id", key: "id" },
    { title: "Proveedor", dataIndex: "nombreProveedor", key: "nombreProveedor" },
    { title: "NIT", dataIndex: "nit", key: "nit" },
    { title: "Ciudad", dataIndex: "ciudad", key: "ciudad" },
    { title: "Teléfono", dataIndex: "telefono", key: "telefono" },
    { title: "Tipo Contrato", dataIndex: "tipoContrato", key: "tipoContrato" },
    { title: "Estado", dataIndex: "descripcion", key: "descripcion" },
    {
      title: "Fecha",
      dataIndex: "fecha",
      key: "fecha",
      render: (text) => new Date(text).toLocaleDateString(),
    },
    {
      title: "Acciones",
      key: "acciones",
      render: (_, record) => (
        <Button type="link" icon={<EyeOutlined />} onClick={() => handleViewHtml(record.id)}>
          Ver Contrato
        </Button>
      ),
    },
  ];

  // 🔹 Cargar datos
  const fetchCasos = async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        "https://contratosback.azurewebsites.net/api/v1/ObtenerCasosAsignados/1"
      );
      setCasos(res.data);
      setFilteredCasos(res.data);
    } catch (error) {
      console.error("Error al obtener casos:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCasos();
  }, []);

  // 🔹 Filtrar por proveedor
  const onSearch = (value) => {
    const searchText = value.toLowerCase();
    const filtered = casos.filter((c) => c.nombreProveedor.toLowerCase().includes(searchText));
    setFilteredCasos(filtered);
  };

  // 🔹 Recargar tabla
  const handleReload = () => {
    setFilteredCasos(casos);
  };

  // 🔹 Ver contrato en modal
  const handleViewHtml = async (id) => {
    setModalVisible(true);
    setModalLoading(true);
    setModalContent("");
    setIsFullScreen(false);

    try {
      const res = await axios.get(
        `https://contratosback.azurewebsites.net/api/v1/ObtenerContrato/${id}`
      );

      if (res.data && res.data.trim() !== "") {
        setModalContent(res.data);
      } else {
        setModalContent("<p>No hay información disponible para este contrato.</p>");
      }
    } catch (error) {
      console.error("Error al cargar contrato:", error);
      setModalContent(
        "<p style='color:red;'>Error al cargar el contrato, valide si el documento se encuentra generado.</p>"
      );
    } finally {
      setModalLoading(false);
    }
  };

  // 🔹 Alternar pantalla completa
  const toggleFullScreen = () => {
    setIsFullScreen((prev) => !prev);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Card style={{ margin: 20, padding: 20 }}>
        <Title level={3}>Repositorio Contratos</Title>

        {/* 🔍 Buscador y botón */}
        <Space style={{ marginBottom: 20 }}>
          <Search
            placeholder="Buscar por proveedor"
            allowClear
            enterButton="Buscar"
            size="large"
            onSearch={onSearch}
            style={{ width: 300 }}
          />
          <Button type="default" icon={<ReloadOutlined />} size="large" onClick={handleReload}>
            Nueva Busqueda|
          </Button>
        </Space>

        {/* 🗂️ Tabla */}
        {loading ? (
          <Spin size="large" />
        ) : (
          <Table
            columns={columns}
            dataSource={filteredCasos}
            rowKey="id"
            pagination={{ pageSize: 10 }}
            bordered
          />
        )}

        {/* 🔹 Modal para mostrar contrato */}
        <Modal
          title="Contrato"
          open={modalVisible}
          onCancel={() => setModalVisible(false)}
          footer={
            <Button type="primary" onClick={toggleFullScreen}>
              {isFullScreen ? (
                <>
                  <FullscreenExitOutlined /> Salir de Pantalla Completa
                </>
              ) : (
                <>
                  <FullscreenOutlined /> Pantalla Completa
                </>
              )}
            </Button>
          }
          width={isFullScreen ? "100vw" : 800}
          style={isFullScreen ? { top: 0, padding: 0 } : { top: 20 }}
          bodyStyle={{
            maxHeight: isFullScreen ? "calc(100vh - 100px)" : "70vh",
            overflowY: "auto",
          }}
        >
          {modalLoading ? (
            <Spin size="large" />
          ) : (
            <div dangerouslySetInnerHTML={{ __html: modalContent }} />
          )}
        </Modal>
      </Card>
    </DashboardLayout>
  );
};

export default ConsultaAbastecimiento;
